import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { KoanBusinessCardStackContentViewModel } from './koan-business-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-koan-business-card-stack-content',
  templateUrl: './koan-business-card-stack-content.component.html',
  styleUrls: ['./koan-business-card-stack-content.component.scss'],
  providers: [KoanBusinessCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class KoanBusinessCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: KoanBusinessCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
